<template>
    <div>
        <client-modal :show="isShowingStopSyncingAlertModal" @close="cancelSyncAlert">
            <div class="p-10 text-gray font-avertaLight">
                <h3 class="font-averta text-2xl text-red mb-4">Stopp i lagens namn!</h3>

                <p class="mb-4 block">Är du säker på att du vill ändra uppgifter enbart för Företagssida <strong class="font-averta uppercase">{{ currentEditingCity().city.name }}</strong>? Det är helt i sin ordning om det är så att ni vill ha specifika uppgifter för denna stad. Detta innebär att om ni sedan gör ändringar på Företagssidan, så kommer inte dessa att synkas till Företagssida <strong class="font-averta uppercase">{{ currentEditingCity().city.name }}</strong>. Vill ni ändra på den staden, så behöver ni gå in och göra ändringarna manuellt på den sidan.</p>

                <div class="flex">
                    <secondary-button @click="proceedSyncAlert">
                        Ändra Företagssida {{ currentEditingCity().city.name }}
                    </secondary-button>

                    <primary-button class="ml-auto" @click="cancelSyncAlert">
                        Tillbaka till Företagssidan
                    </primary-button>
                </div>
            </div>
        </client-modal>

        <client-modal :enableCloseButton="true" :show="isShowingFirstImageInfoModal" @close="() => isShowingFirstImageInfoModal = false">
            <div class="p-10 text-gray font-avertaLight">
                Här laddar du upp den bilden som kommer att visas längst upp på din företagssida. (<i>Tänk på att ni måste äga rättigheterna till bilden</i>) Om du inte laddar upp en bild här kommer din företagssida endast bestå av text. Bilder säljer, så vi tycker verkligen att du ska lägga ner tid på att lösa detta. Storleken bör vara 800x600 pixlar för att visas på bästa sätt.
            </div>
        </client-modal>

        <client-modal :enableCloseButton="true" :show="isShowingSecondImageInfoModal" @close="() => isShowingSecondImageInfoModal = false">
            <div class="p-10 text-gray font-avertaLight">
                Här laddar du upp bilden som kommer att visas som bild nummer två, längre ner, på din företagssida. (<i>Tänk på att ni måste äga rättigheterna till bilden</i>) Om du inte laddar upp en bild här kommer utrymmet för bilden inte att synas. Men bilder säljer, så vi tycker verkligen att du ska lägga ner tid på att hitta en bild som passar även här. Storleken bör vara 800x600 pixlar för att visas på bästa sätt.
            </div>
        </client-modal>

        <client-modal :show="isShowingSidebarPopup">
            <div class="p-10 text-gray">
                <h3 class="font-averta text-2xl text-red mb-4">Min företagssida</h3>

                <p class="font-avertaLight text-gray block mb-4">Min företagssida är det som blir Ditt företags egna sida på familjekortet.se. Samtliga uppgifter som du anger här kommer att vara synliga för våra medlemmar! Se därför till att alltid ha aktuella uppgifter inlagda.</p>

                <p class="font-avertaLight text-gray block mb-4">Vi har lagt in förklaringar och lite tips och råd vid varje steg. Ta dig tiden att läsa igenom dem innan, så blir det lättare sen :) Genom att ladda upp schyssta bilder (<i>tänk på att ni som företag måste äga rättigheterna till bilderna</i>) och välskrivna texter, så är det mycket troligt att Ditt företag kommer att hamna högre upp i google-sökningar.</p>

                <p class="font-avertaLight text-gray block mb-4">Tillsammans blir vi starkare!</p>

                <div class="flex">
                    <primary-button @click="closeSidebarPopup">Nu kör vi!</primary-button>

                    <!-- <secondary-button class="ml-2">Ge mig lite fler tips</secondary-button> -->
                </div>
            </div>
        </client-modal>

        <client-modal :full-page="true" :show="isShowingPreviewModal" @close="isShowingPreviewModal = false">
            <div class="bg-white min-h-screen">
                <page-preview
                    ref="pagePreview"
                    :data="previewData"
                    :company="company"
                    @close="isShowingPreviewModal = false"></page-preview>
            </div>
        </client-modal>

        <client-modal :show="isShowingSaveOptionsModal" @close="() => isShowingSaveOptionsModal = false">
            <div class="p-10">
                <h3 class="font-averta text-2xl text-red mb-4">Snart klar?</h3>

                <div class="font-avertaLight">Företagssidan är inte live på familjekortet.se än. Vill du spara utan att publicera företagssidan, så väljer du bara spara. Annars så väljer du publicera!</div>

                <div class="flex mt-4">
                    <secondary-button @click="startPublish" class="ml-auto mr-2">
                        Publicera
                    </secondary-button>

                    <primary-button @click="startSave">
                        Spara
                    </primary-button>
                </div>
            </div>
        </client-modal>

        <!-- <client-modal :show="isShowingChangeCityConfirmationModal" @close="cancelCityChange">
            <div class="p-6">
                <form v-on:submit.prevent="changeCity">
                    <div class="mb-4 bg-red text-white px-4 py-2 rounded-md font-semibold flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                        </svg>

                        <span>Kom ihåg att spara dina ändringar innan du byter stad, annars kommer du förlora dom.</span>
                    </div>

                    <primary-button
                        class="mr-2">
                        Byt stad
                    </primary-button>

                    <secondary-button
                        type="button"
                        @click="cancelCityChange">
                        Avbryt
                    </secondary-button>
                </form>
            </div>
        </client-modal> -->

        <client-modal :show="isShowingEditingCompanyInfoModal" @close="isShowingEditingCompanyInfoModal = false">
            <div class="p-10">
                <h3 class="font-averta text-2xl text-red mb-4">Företagstext</h3>

                <div class="mb-4">
                    <input type="text" class="opacity-0 absolute right-0 z-[-1]" />

                    <input-field
                        v-model="form[editingCity].heading"
                        :error="form.errors.heading"
                        :tooltipEnabled="true"
                        @input="form.errors.heading = null"
                        label="Rubrik för presentation"
                        placeholder="Rubrik">

                        <template #tooltip>
                            Här ska du ange en rubrik som sammanfattar er verksamhet och väcker nyfikenhet. Håll den kort och informativ och använd ord som är viktiga för er verksamhet: Ex: BARNKLÄDER OCH BABYKLÄDER PÅ NÄTET
                        </template>
                    </input-field>
                </div>

                <div class="mb-4">
                    <html-editor-field
                        v-model="form[editingCity].info"
                        :error="form.errors.info"
                        :tooltipEnabled="true"
                        @input="form.errors.info = null"
                        label="Beskrivning av ditt företag">

                        <template #tooltip>
                            Här ska du ange en kort text som sammanfattar er verksamhet och väcker nyfikenhet. Håll den kort och informativ och använd ord som är viktiga för er verksamhet.
                        </template>
                    </html-editor-field>
                </div>

                <div class="flex">
                    <primary-button
                        type="button"
                        class="ml-auto"
                        @click="isShowingEditingCompanyInfoModal = false">
                        Spara
                    </primary-button>
                </div>
            </div>
        </client-modal>

        <client-modal :show="isShowingEditingCompanyContactModal" @close="isShowingEditingCompanyContactModal = false">
            <div class="p-10">
                <h3 class="font-averta text-2xl text-red mb-4">Kontaktuppgifter</h3>

                <input-field
                    v-model="form[editingCity].public_url"
                    :error="form.errors.public_url"
                    label="Hemsida"
                    name="public_url"
                    class="mb-4" />

                <input-field
                    v-model="form[editingCity].public_phone_number"
                    :error="form.errors.public_phone_number"
                    label="Telefon"
                    name="public_phone_number"
                    class="mb-4" />

                <input-field
                    v-model="form[editingCity].public_email_address"
                    :error="form.errors.public_email_address"
                    @input="form.errors.public_email_address = null"
                    label="E-post"
                    name="public_email_address"
                    class="mb-4" />

                <input-field
                    v-model="form[editingCity].public_street_address"
                    :error="form.errors.public_street_address"
                    label="Besöksadress"
                    name="public_street_address"
                    class="mb-4" />

                <div class="mb-4 flex -mx-2">
                    <div class="w-1/2 mx-2">
                        <input-field
                            v-model="form[editingCity].public_zip_code"
                            :error="form.errors.public_zip_code"
                            label="Postnummer"
                            name="public_zip_code" />
                    </div>

                    <div class="w-1/2 mx-2">
                        <input-field
                            v-model="form[editingCity].public_city"
                            :error="form.errors.public_city"
                            label="Ort"
                            name="public_city" />
                    </div>
                </div>

                <div class="mb-4 flex -mx-2">
                    <div class="w-1/2 mx-2">
                        <input-field
                            v-model="form[editingCity].fb_url"
                            :error="form.errors.fb_url"
                            label="Facebook (länk)"
                            name="fb_url" />
                    </div>

                    <div class="w-1/2 mx-2">
                        <input-field
                            v-model="form[editingCity].ig_url"
                            :error="form.errors.ig_url"
                            label="Instagram (länk)"
                            name="ig_url" />
                    </div>
                </div>

                <div class="flex">
                    <primary-button
                        type="button"
                        @click="isShowingEditingCompanyContactModal = false"
                        class="ml-auto">
                        Spara
                    </primary-button>
                </div>
            </div>
        </client-modal>

        <client-modal :show="isShowingCropper('firstImage')" @close="closeCropper('firstImage')">
            <div class="p-6">
                <div class="mb-4" :class="{ 'border-2 border-blue': form['default'].company_first_image.tmp_cropper === null }">
                    <image-upload
                        ref="companyFirstImageUpload"
                        @image-selected="(image, file) => imageUploaded('firstImage', image, file)"/>

                    <image-cropper
                        ref="companyFirstImageCropper"
                        :zoom-on-wheel="false"
                        :zoom-on-touch="false"
                        :view-mode="1"
                        :auto-crop-area="1"
                        :aspect-ratio="4/3"
                        :zoom-slider="true"
                        :toolbar="false"
                        :background="false"
                        @on-change="(value) => cropperChanged('firstImage', value)"
                        @on-crop="(canvas) => onCrop('firstImage', canvas)"/>
                </div>

                <div class="flex">
                    <secondary-button
                        type="button"
                        @click="startImageUpload('firstImage')">
                        Byt bild
                    </secondary-button>

                    <secondary-button
                        type="button"
                        class="ml-auto mr-2"
                        @click="closeCropper('firstImage')">
                        Avbryt
                    </secondary-button>

                    <primary-button
                        type="button"
                        @click="performCrop('firstImage')">
                        Använd bild
                    </primary-button>
                </div>
            </div>
        </client-modal>

        <client-modal :show="isShowingCropper('secondImage')" @close="closeCropper('secondImage')">
            <div class="p-6">
                <div class="mb-4" :class="{ 'border-2 border-blue': form['default'].company_second_image.tmp_cropper === null }">
                    <image-upload
                        ref="companySecondImageUpload"
                        @image-selected="(image, file) => imageUploaded('secondImage', image, file)"/>

                    <image-cropper
                        ref="companySecondImageCropper"
                        :zoom-on-wheel="false"
                        :zoom-on-touch="false"
                        :view-mode="1"
                        :auto-crop-area="1"
                        :aspect-ratio="4/3"
                        :zoom-slider="true"
                        :toolbar="false"
                        :background="false"
                        @on-change="(value) => cropperChanged('secondImage', value)"
                        @on-crop="(canvas) => onCrop('secondImage', canvas)"/>
                </div>

                <div class="flex">
                    <secondary-button
                        type="button"
                        @click="startImageUpload('secondImage')">
                        Byt bild
                    </secondary-button>

                    <secondary-button
                        type="button"
                        class="ml-auto mr-2"
                        @click="closeCropper('secondImage')">
                        Avbryt
                    </secondary-button>

                    <primary-button
                        type="button"
                        @click="performCrop('secondImage')">
                        Använd bild
                    </primary-button>
                </div>
            </div>
        </client-modal>

        <client-modal :show="isShowingCropper('logoImage')" @close="closeCropper('logoImage')">
            <div class="p-6">
                <div class="mb-4" :class="{ 'border-2 border-blue': form['default'].company_logo.tmp_cropper === null }">
                    <image-cropper
                        ref="companyLogoCropper"
                        :circle="true"
                        :zoom-on-wheel="false"
                        :zoom-on-touch="false"
                        :view-mode="1"
                        :auto-crop-area="1"
                        :aspect-ratio="1"
                        :zoom-slider="true"
                        :toolbar="false"
                        @on-change="(value) => cropperChanged('logoImage', value)"
                        @on-crop="(canvas) => onCrop('logoImage', canvas)"/>
                </div>

                <div class="flex">
                    <secondary-button
                        type="button"
                        @click="closeCropper('logoImage')">
                        Avbryt
                    </secondary-button>

                    <primary-button
                        type="button"
                        @click="performCrop('logoImage')"
                        class="ml-auto">
                        Använd bild
                    </primary-button>
                </div>
            </div>
        </client-modal>

        <image-upload
            ref="cropperCompanyLogoUpload"
            @image-selected="showCompanyLogoCropper" />

        <client-modal :show="isShowingCompanyLogoMethodModal" @close="isShowingCompanyLogoMethodModal = false">
            <div class="p-6 max-w-xl">
                <template v-if="form['default'].company_logo.image">
                    <div class="flex -mx-4">
                        <secondary-button
                            @click="showCurrentLogoCropper"
                            class="w-full mx-4">
                            Beskär nuvarande
                        </secondary-button>

                        <secondary-button
                            @click="markImageAsDeleted('logoImage')"
                            class="w-full mx-4">
                            Ta bort bild
                        </secondary-button>
                    </div>

                    <div class="flex justify-center items-center">
                        <div class="bg-blue rounded-full max-w-[70%] h-[2px] w-full my-6"></div>
                    </div>
                </template>

                <div class="flex -mx-4">
                    <secondary-button
                        @click="startCompanyLogoImageUploading" class="w-full mx-4">
                        Ladda upp och beskär
                    </secondary-button>

                    <image-upload
                        ref="directCompanyLogoUpload"
                        @image-selected="companyLogoUploadedDirectly" />

                    <secondary-button
                        @click="$refs.directCompanyLogoUpload.triggerFileInputDialog(true)"
                        class="w-full mx-4">
                        Ladda upp direkt
                    </secondary-button>
                </div>
            </div>
        </client-modal>

        <div class="flex flex-col md:flex-row md:h-12 items-center mb-6 md:mb-2">
            <h2 class="text-md md:text-2xl text-red font-avertaBold"><span class="uppercase">Mina sidor Företag</span> / <span class="font-averta">Min företagssida</span></h2>
        </div>

        <div class="text-sm text-gray mb-10 max-w-2xl">
            Min företagssida är det som blir Ditt företags egna sida på familjekortet.se. Samtliga uppgifter som du anger här kommer att vara synliga för våra medlemmar! Se därför till att alltid ha aktuella uppgifter inlagda. Vi har lagt in förklaringar och lite tips och råd vid varje steg. Ta dig tiden att... <a href="javascript:void(0)" @click="isShowingSidebarPopup = true" class="underline">Läs mer</a>
        </div>

        <div class="bg-white my-6 w-full px-4 py-3 rounded-md shadow-sm flex sticky top-[82px] z-[10]">
            <select
                v-if="companyCities.length > 0"
                class="border-2 border-blue rounded-md focus:outline-none focus-visible:border-blue-600 px-4 py-1 pr-8"
                v-model="editingCity">
                <option value="default">Företagssida</option>
                <option v-for="companyCity in companyCities" :value="companyCity.city.slug">Företagssida {{ companyCity.city.name }}</option>
            </select>

            <div v-if="companyCities.length === 0" class="flex items-center text-gray font-averta">E-Handel</div>

            <div class="ml-auto">
                <secondary-button @click="startPreview">
                    Förhandsgranska
                </secondary-button>

                <!-- <primary-button :loading="isSaving" @click="save" class="ml-2">
                    <span v-if="!step.isCompleted()">Spara och gå live!</span>
                    <span v-else>Spara</span>
                </primary-button> -->

                <primary-button v-if="!step.isCompleted()" :loading="isSaving" @click="isShowingSaveOptionsModal = true" class="ml-2">
                    Spara
                </primary-button>

                <primary-button v-if="step.isCompleted()" :loading="isSaving" @click="save" class="ml-2">
                    Spara
                </primary-button>
            </div>
        </div>

        <div v-if="editingCity !== 'default'" class="bg-red text-white mb-4 px-4 py-2 font-averta text-center text-xl">
            Du ändrar just nu företagssidan för <strong class="font-averta uppercase">{{ companyCities.find(c => c.city.slug === editingCity).city.name }}</strong>
        </div>

        <div class="relative">
            <div class="md:flex">
                <div class="md:w-1/2 relative">
                    <div class="absolute right-[10px] top-[10px] bg-blue z-[9] rounded-md">
                        <div class="flex">
                            <div v-tippy="'Ladda upp bild'" v-if="form['default'].company_first_image.image_crop" @click="startCropperFileInputDialog('firstImage')" class="block cursor-pointer border-r border-blue-600 px-2 py-1">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-700" viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM6.293 6.707a1 1 0 010-1.414l3-3a1 1 0 011.414 0l3 3a1 1 0 01-1.414 1.414L11 5.414V13a1 1 0 11-2 0V5.414L7.707 6.707a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                                </svg>
                            </div>

                            <div v-tippy="'Redigera bild'" v-if="form['default'].company_first_image.image_crop" @click="startCropperWithCurrentImage('firstImage')" class="block cursor-pointer border-r border-blue-600 px-2 py-1">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-700" viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd" d="M9 3a1 1 0 012 0v5.5a.5.5 0 001 0V4a1 1 0 112 0v4.5a.5.5 0 001 0V6a1 1 0 112 0v5a7 7 0 11-14 0V9a1 1 0 012 0v2.5a.5.5 0 001 0V4a1 1 0 012 0v4.5a.5.5 0 001 0V3z" clip-rule="evenodd" />
                                </svg>
                            </div>

                            <div v-tippy="'Radera bild'" v-if="form['default'].company_first_image.image_crop" @click="markImageAsDeleted('firstImage')" class="block cursor-pointer border-r border-blue-600 px-2 py-1">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-700" viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
                                </svg>
                            </div>

                            <div v-if="renderTippys" v-tippy="{content: 'Information', showOnCreate: !form['default'].company_first_image.image_crop}"  @click="isShowingFirstImageInfoModal = true" class="block cursor-pointer px-2 py-1">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            </div>
                        </div>
                    </div>

                    <div class="aspect-w-4 aspect-h-3 border-2 border-dashed border-secondaryBlue" :class="{ 'border-opacity-0': form['default'].company_first_image.image_crop }">
                        <img v-if="form['default'].company_first_image.image_crop" :src="form['default'].company_first_image.image_crop" />

                        <div v-if="!form['default'].company_first_image.image_crop" class="flex justify-center items-center">
                            <secondary-button
                                @click="startCropperFileInputDialog('firstImage')">
                                Ladda upp bild
                            </secondary-button>
                        </div>
                    </div>
                </div>

                <div class="md:hidden">
                    <div class="flex justify-center md:mt-[-75px] md:mb-[-75px]">
                        <div @click="isShowingCompanyLogoMethodModal = true" class="
                            z-[9] rounded-full bg-white overflow-hidden hover:cursor-pointer
                            w-[24vw] h-[24vw] mt-[-12vw]
                            ">
                            <div class="flex h-full justify-center items-center">
                                <img :src="form['default'].company_logo.image_crop" class="w-full" />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-5 mb-5 md:mb-0 md:mt-0 md:w-1/2 relative">
                    <div class="absolute right-[25px] top-[10px] bg-gray-400 z-[9] rounded-md">
                        <div class="flex">
                            <secondary-button style="background: #f8fafc !important;" @click="startEditCompanyInfo">
                                Företagstext
                            </secondary-button>

                            <!-- <button @click="isShowingEditingCompanyInfoModal = true" class="block px-2 py-1">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                </svg>
                            </button> -->
                        </div>
                    </div>

                    <div class="pt-4 md:pl-16 pr-5 overflow-auto">
                        <div class="md:aspect-w-4 md:aspect-h-3">
                            <div class="pt-[60px]">
                                <p v-if="form[editingCity].heading" class="uppercase font-semibold font-averta-black">{{ form[editingCity].heading }}</p>
                                <p v-else class="uppercase font-semibold font-averta-black">Välj några få, men viktiga ord, som i en kort mening beskriver din verksamhet.</p>

                                <div v-if="form[editingCity].info" class="mt-4 client-page-company-html-info" v-html="form[editingCity].info"></div>
                                <div v-else class="mt-4 client-page-company-html-info">Här ska du ange en kort text som sammanfattar er verksamhet och väcker nyfikenhet. Håll den kort och informativ och använd ord som är viktiga för er verksamhet, då dessa hjälper er i SEO-djungeln och då kan förbättra er synlighet.</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="hidden md:flex justify-center md:mt-[-75px] md:mb-[-75px]">
                <div class="z-[9] relative">
                    <div @click="isShowingCompanyLogoMethodModal = true"
                        class="absolute top-[8px] right-[8px] bg-blue rounded-full overflow-hidden hover:cursor-pointer px-1 py-1">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                        </svg>
                    </div>

                    <div @click="isShowingCompanyLogoMethodModal = true" :class="{ 'border-opacity-0 bg-white': form['default'].company_logo.image_crop }" class="
                        rounded-full bg-[#f8fafc] overflow-hidden hover:cursor-pointer
                        w-[150px] h-[150px]
                        border-2 border-secondaryBlue border-dashed
                        ">
                        <div class="flex h-full justify-center items-center">
                            <secondary-button v-if="!form['default'].company_logo.image_crop">Logga</secondary-button>
                            <img v-if="form['default'].company_logo.image_crop" :src="form['default'].company_logo.image_crop" class="w-full" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex flex-col flex-col-reverse md:flex-row">
                <div class="md:w-1/2 relative">
                    <div class="absolute left-[19px] top-[10px] bg-gray-400 z-[9] rounded-md">
                        <div class="flex">
                            <secondary-button @click="startEditCompanyContact" class="mt-6">
                                Kontaktuppgifter
                            </secondary-button>

                            <!-- <button @click="isShowingEditingCompanyContactModal = true" class="block px-2 py-1">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                </svg>
                            </button> -->
                        </div>
                    </div>

                    <div class="pt-[60px] pr-16 pl-16 overflow-auto">
                        <div class="md:aspect-w-4 md:aspect-h-3">
                            <div @click="isShowingEditingCompanyContactModal = true" class="hover:cursor-pointer pt-[50px]">
                                <p class="uppercase mb-8 font-semibold">Kontakta {{ company.name }}</p>

                                <table>
                                    <tr>
                                        <td :class="{ 'text-gray-400': !form[editingCity].public_url }">Webb:</td>
                                        <td class="pl-2"><a href="javascript:void(0)" class="underline">Klicka här</a></td>
                                    </tr>

                                    <tr>
                                        <td :class="{ 'text-gray-400': !form[editingCity].public_phone_number }">Telefon:</td>
                                        <td class="pl-2">
                                            <a href="javascript:void(0)" class="underline">{{ form[editingCity].public_phone_number || '+461234567' }}</a>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td :class="{ 'text-gray-400': !form[editingCity].public_email_address }">E-post:</td>
                                        <td class="pl-2">
                                            <a href="javascript:void(0)" class="underline">{{ form[editingCity].public_email_address || 'info@dittforetag.se' }}</a>
                                        </td>
                                    </tr>
                                </table>

                                <div class="mt-4">
                                    <i v-if="form[editingCity].fb_url" class="fab fa-facebook-square fa-2x text-[#4267B2]"></i>
                                    <i v-else class="fab fa-facebook-square fa-2x text-gray-400"></i>

                                    <i v-if="form[editingCity].ig_url" class="fab fa-instagram fa-2x ml-1" style=" background: #d6249f; background: radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%,#d6249f 60%,#285AEB 90%);  -webkit-background-clip: text; -webkit-text-fill-color: transparent;"></i>
                                     <i v-else class="fab fa-instagram fa-2x ml-1 text-gray-400"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="md:w-1/2 relative">
                    <div class="absolute right-[10px] top-[10px] bg-blue z-[9] rounded-md">
                        <div class="flex">
                            <div v-tippy="'Ladda upp bild'" v-if="form['default'].company_second_image.image_crop" @click="startCropperFileInputDialog('secondImage')" class="block cursor-pointer border-r border-blue-600 px-2 py-1">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-700" viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM6.293 6.707a1 1 0 010-1.414l3-3a1 1 0 011.414 0l3 3a1 1 0 01-1.414 1.414L11 5.414V13a1 1 0 11-2 0V5.414L7.707 6.707a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                                </svg>
                            </div>

                            <div v-tippy="'Redigera bild'" v-if="form['default'].company_second_image.image_crop" @click="startCropperWithCurrentImage('secondImage')" class="block cursor-pointer border-r border-blue-600 px-2 py-1">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-700" viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd" d="M9 3a1 1 0 012 0v5.5a.5.5 0 001 0V4a1 1 0 112 0v4.5a.5.5 0 001 0V6a1 1 0 112 0v5a7 7 0 11-14 0V9a1 1 0 012 0v2.5a.5.5 0 001 0V4a1 1 0 012 0v4.5a.5.5 0 001 0V3z" clip-rule="evenodd" />
                                </svg>
                            </div>

                            <div v-tippy="'Radera bild'" v-if="form['default'].company_second_image.image_crop" @click="markImageAsDeleted('secondImage')" class="block cursor-pointer border-r border-blue-600 px-2 py-1">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-700" viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
                                </svg>
                            </div>

                            <div v-if="renderTippys" v-tippy="{content: 'Information', showOnCreate: !form['default'].company_second_image.image_crop}" @click="isShowingSecondImageInfoModal = true" class="block cursor-pointer px-2 py-1">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            </div>
                        </div>
                    </div>

                    <div class="aspect-w-4 aspect-h-3 border-2 border-dashed border-secondaryBlue" :class="{ 'border-opacity-0': form['default'].company_second_image.image_crop }">
                        <img v-if="form['default'].company_second_image.image_crop" :src="form['default'].company_second_image.image_crop" />

                        <div v-if="!form['default'].company_second_image.image_crop" class="flex justify-center items-center">
                            <secondary-button
                                @click="startCropperFileInputDialog('secondImage')">
                                Ladda upp bild
                            </secondary-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script src="./PageMixin.js"></script>
